module.exports = __webpack_public_path__ + "img/gif_solenoid_value.d2190b60.gif";